import styled from "styled-components";

export const UserContainer = styled.div`
  margin-top: 5px;
  .ant-pagination {
    align-items: left;
    justify-content: left;
    display: flex;
    width: 100%;
    margin-top: 30px;
  }

  .ant-table-pagination.ant-pagination {
    margin-bottom: 0;
  }

  .ant-pagination-options {
    margin-left: auto;
  }
  .ant-pagination-total-text {
    margin-right: auto;
  }

  .ant-pagination-item {
    border: none;
  }
  .ant-pagination-item-link {
    border: none;
  }

  .pencilEdit {
    color: ${(props) => props.theme.colors.text};
    cursor: pointer;
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .pencilDisabledEdit {
    color: ${(props) => props.theme["@disabled-button"]};
    cursor: not-allowed;
  }
`;

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: auto;
  margin-top: 5px;
`;

export const SearchInput = styled.div`
  margin-left: auto;
`;
